import React, { useEffect, useState, useCallback } from 'react'
import {
  CompanySearchItem,
  useCompany,
  useCompanies,
} from '../../../../services/api/companies'
import { View } from './View'
import { defaultPagination } from '../../../../services/api/client/types'

const SEARCH_TIMEOUT = 1000
type Props = {
  companyId?: string
  onCompanyChange: (companyId?: string) => void
}

export const Container: React.FunctionComponent<Props> = ({
  companyId,
  onCompanyChange,
}) => {
  const [getCompany, { isLoading }] = useCompany(companyId as string)
  const [debounceSearch, setDebounceSearch] = useState<any>()
  const [getCompanies, { isLoading: isSearching }] = useCompanies()
  const [selectedCompany, setSelectedCompany] = useState<CompanySearchItem>()
  const [availableCompanies, setAvailableCompanies] = useState<
    CompanySearchItem[]
  >([])

  const availableCompany = useCallback(
    (value?: string): CompanySearchItem | undefined => {
      return availableCompanies.find((company) => company.id === value)
    },
    [availableCompanies]
  )

  useEffect(() => {
    if (companyId && companyId !== '' && companyId !== selectedCompany?.id) {
      const company = availableCompany(companyId)
      if (company) {
        setSelectedCompany(company)
      } else {
        getCompany().then((response) => setSelectedCompany(response.data))
      }
    }
  }, [availableCompany, companyId, getCompany, selectedCompany])

  useEffect(() => {
    if (!companyId && selectedCompany) {
      setSelectedCompany(undefined)
    }
  }, [companyId, selectedCompany])

  useEffect(() => {
    getCompanies({ ...defaultPagination }).then((response) => {
      setAvailableCompanies(response.data)
    })
  }, [getCompanies])

  const handleChange = (value?: string): void => {
    onCompanyChange(value)
  }

  const handleSearch = (value?: string) => {
    if (debounceSearch) {
      clearTimeout(debounceSearch)
    }
    setDebounceSearch(
      setTimeout(() => {
        getCompanies({
          search: value === '' ? undefined : value,
          ...defaultPagination,
        }).then((response) => {
          setAvailableCompanies(response.data)
        })
      }, SEARCH_TIMEOUT)
    )
  }

  return (
    <View
      selectedCompany={selectedCompany}
      availableCompanies={availableCompanies}
      isLoading={isLoading}
      isSearching={isSearching}
      handleChange={handleChange}
      handleSearch={handleSearch}
    />
  )
}
